import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root',
})
export class ExcelExportService {
  /**
   * Export a plain HTML table element to Excel using its DOM id.
   * Column headers and cell text are captured as-is from the rendered table.
   * Append a timestamp so successive exports don't overwrite each other.
   */
  exportFromTable(tableId: string, filename: string): void {
    const element = document.getElementById(tableId);
    if (!element) {
      console.warn(`ExcelExportService: element with id "${tableId}" not found.`);
      return;
    }
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, filename + formatDate(new Date(), 'yyyyMMdd_HHmm', 'en') + '.xlsx');
  }

  /**
   * Export an array of plain objects to Excel.
   * Object keys become column headers; values become cell data.
   * Prefer this over exportFromTable when you want clean column names
   * and need to exclude action-button or UI-only columns.
   */
  exportFromJson(data: Record<string, any>[], filename: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, filename + formatDate(new Date(), 'yyyyMMdd_HHmm', 'en') + '.xlsx');
  }
}
